import { Achievement } from '../types';
import api from './config';

const ACHIEVEMENT_API_URL = `${process.env.REACT_APP_SERVER_URL}/achievement`;

/**
 * Increments the progress of an achievement.
 * @param aid The achievement id.
 * @returns The updated achievement.
 */
const incrementAchievement = async (aid: string): Promise<Achievement> => {
  const res = await api.post(`${ACHIEVEMENT_API_URL}/incrementAchievement`, { aid });

  if (res.status !== 200) {
    throw new Error('Error while incrementing achievement');
  }
  return res.data;
};

export default incrementAchievement;
